export default "__VITE_ASSET__D3Ml65Ld__"